import { render, staticRenderFns } from "./BookDetail.vue?vue&type=template&id=5d55e31a&scoped=true&"
import script from "./BookDetail.vue?vue&type=script&lang=js&"
export * from "./BookDetail.vue?vue&type=script&lang=js&"
import style0 from "./BookDetail.vue?vue&type=style&index=0&id=5d55e31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d55e31a",
  null
  
)

export default component.exports